module.exports = __webpack_public_path__ + "assets/beschikbaarheid1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/beschikbaarheid1.jpg
// module id = 354
// module chunks = 0